import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useFamilyStore } from '@/store/familyStore';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface AddFirstMemberDialogProps {
  open: boolean;
  onClose: () => void;
}

export function AddFirstMemberDialog({ open, onClose }: AddFirstMemberDialogProps) {
  const [name, setName] = useState('');
  const { addMember } = useFamilyStore();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      // Add the first member as root
      const newMember = {
        id: crypto.randomUUID().replace(/[-]/g, ""),
        name: name.trim(),
        children: []
      };
      
      addMember(newMember);
      setName('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>إضافة عضو جديد</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">الاسم</Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="أدخل اسم العضو"
              autoFocus
            />
          </div>
          <div className="flex gap-2">
            <Button type="submit" disabled={!name.trim()} className="flex-1">
              إضافة
            </Button>
            <Button type="button" variant="outline" onClick={onClose} className="flex-1">
              إلغاء
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
